import React from 'react';
import { connect } from "react-redux";
import ModalComponent from "../Modal";
import EditPassword from "./editPassword";
import { withCookies } from 'react-cookie';
import Notice from "../Notification/newNotification";
import { PASSWORD_MIN_LENGTH } from "../../shared/constants";
import { updateProfile } from "../../containers/Layouts/User/Profile/actions";

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isUpdating: false,
            user: {
                id: this.props.auth.currentUser.id,
                email: this.props.auth.currentUser.email,
                oldPassword: '',
                newPassword: '',
                rePassword: ''
            },
            validationErrors: {
                oldPassword: {
                    message: '',
                    state: 'invalid'
                },
                password: {
                    message: '',
                    state: 'invalid'
                },
                rePassword: {
                    message: '',
                    state: 'invalid'
                },
            }
        }
        this.closeModal = this.closeModal.bind(this);
    }

    componentWillReceiveProps (nextProps) {
        if (nextProps.profile.updated && this.state.isUpdating) {
            Notice.addNotification('Password successfully updated!', 'success');
            this.closeModal();
        }
        if (nextProps.profile.updated === false && this.state.isUpdating) {
            Notice.addNotification(nextProps.profile.error, 'error');
            this.setState({ isUpdating: false });
        }
    }

    handleChange = (key, value) => {
        const {user} = this.state
        user[key] = value
        this.setState({user})
        this.validation(key, value)
    }

    validateInputFields (key, value) {
        if (!['password', 'oldPassword', 'newPassword'].includes(key)) {
            const object = (value.trim() === '') ? {status: true, message: `This field is required!`} : {status: false, message: ''}
            this.setState({
                validationErrors: {
                    ...this.state.validationErrors,
                    [key]: object
                }
            })
        }
    }

    validation (key, value) {
        this.validateInputFields (key, value);

        if (key === 'oldPassword') {
            if ((value.trim().length >= PASSWORD_MIN_LENGTH)) {
                Object.assign(this.state.validationErrors, {oldPassword: {status: false, message: ''}})
                if ((this.state.user.rePassword === this.state.user.newPassword && this.state.user.newPassword.length >= PASSWORD_MIN_LENGTH)) {
                    this.setState({confirmButtons: {password: true}})
                }
            } else {
                Object.assign(this.state.validationErrors, {oldPassword: {status: true, message: `Password must be at least ${PASSWORD_MIN_LENGTH} character.`}})
                return this.setState({confirmButtons: {password: false}})
            }
        } else if (key === 'newPassword') {
            if (value.trim() && this.state.user.newPassword.length >= PASSWORD_MIN_LENGTH) {
                Object.assign(this.state.validationErrors, {password: {status: false, message: ''}})
                if (this.state.user.newPassword === this.state.user.rePassword) {
                    this.setState({confirmButtons: { ...this.state.confirmButtons, password: true }})
                }
            } else {
                this.setState({
                    validationErrors: {
                        ...this.state.validationErrors,
                        password: {
                            status: true,
                            message: `Password must be at least ${PASSWORD_MIN_LENGTH} character.`
                        }
                    },
                    confirmButtons: { ...this.state.confirmButtons, password: false }
                });
            }
        } else if (key === 'rePassword') {
            let message = '';
            let status = false;
            let confirmButtons = true;
            if (this.state.user.newPassword !== this.state.user.rePassword) {
                message = 'Your passwords do not match. Please try again.';
                status = true;
                confirmButtons = false
            }
            this.setState({
                validationErrors: {
                    ...this.state.validationErrors,
                    rePassword: { status: status, message: message }
                },
                confirmButtons: { ...this.state.confirmButtons, password: confirmButtons }
            });

        }
    }

    handleUpdate = (e, updateField = '') => {
        e.preventDefault();
        if(!updateField){
            this.setState({ isUpdating: true });
            this.props.updateProfile({...this.state.user, updateField})
        } else {
            const {oldPassword, newPassword, rePassword} = this.state.user;
            let isValid = true;
            let {validationErrors} = this.state
            if (oldPassword.length === 0) {
                isValid = false;
                validationErrors = {
                    ...validationErrors,
                    oldPassword: {
                        status: true,
                        message: 'Old password field is required.'
                    }
                }
            } else if (validationErrors.oldPassword.status) {
                isValid = false;
            }
            if (newPassword.length === 0) {
                isValid = false;
                validationErrors = {
                    ...validationErrors,
                    password: {
                        status: true,
                        message: 'New password field is required.'
                    }
                }
            }
            if (validationErrors.password.status) {
                isValid = false;
            }
            if (rePassword.length === 0) {
                isValid = false;
                validationErrors = {
                    ...validationErrors,
                    rePassword: {
                        status: true,
                        message: 'Confirm password field is required.'
                    }
                }
            }
            if (validationErrors.rePassword.status) {
                isValid = false;
            }
            if (isValid) {
                this.setState({ isUpdating: true });
                this.props.updateProfile({...this.state.user, updateField})
            } else {
                this.setState({validationErrors})
            }
        }
    }

    closeModal() {
        this.props.closeModal();
        this.setState({
            isUpdating: false,
            user: {
                ...this.state.user,
                oldPassword: '',
                newPassword: '',
                rePassword: ''
            },
            validationErrors: {
                oldPassword: {
                    message: '',
                    state: false
                },
                password: {
                    message: '',
                    state: false
                },
                rePassword: {
                    message: '',
                    state: false
                },
            }
        });
    }



    render() {
        return (
            <ModalComponent
                dialogClassName="profile__modals"
                modalHeaderStyle="modalHeaderDefault"
                headerTitle="Change Password"
                isAdmin={true}
                modalBody={
                        <EditPassword
                            closeButton={this.closeModal}
                            handleChange={this.handleChange}
                            handleUpdate={this.handleUpdate}
                            confirmButtons={this.state.confirmButtons}
                            validationErrors={this.state.validationErrors}
                            user={this.state.user}
                        />
                }
                show={this.props.isModalOpened}
                handleClose={this.closeModal}
                buttonText="Save"
                buttonFunction={(e) => this.handleUpdate(e, 'password')}
            />
        )
    }
}

const mapStateToProps = state => ({
    auth: state.auth,
    profile: state.profile
});

const mapDispatchToProps = dispatch => {
    return {
        updateProfile: (data) => { dispatch(updateProfile(data)); },
    }
};

export default withCookies(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/components/Profile/editPasswordForm.js